import { Typography } from '@/shared/ui/Typography';
import { EMPTY_PHOTO_BASE64 } from '@/shared/const';
import { LogoutButton } from '@/features/LK/LogoutButton';
import { useUserPhoto, useUserStore } from '@/entities/User';
import { getUserName } from '@/shared/lib/utils/getUserName';
import { Accordion, TAccordionItem } from '@/features/Accordion';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import { formatPhoneNumber } from '../lib/formatPhoneNumber';
import NoProfilePhoto from '@/shared/assets/icons/noProfile.svg?react';
// import { getPersonalDataItems } from '../lib/getPersonalDataItems';
import { getAgreementDataItems } from '../lib/getAgreementDataItems';
import Pencil from '@/shared/assets/icons/pencil.svg?react';
import cls from './Info.module.scss';

type Props = {
    setIsEditingPhoto: (condition: boolean) => void;
};

export const Info = ({ setIsEditingPhoto }: Props) => {
    const { user, userData } = useUserStore();

    const { data: photo, isError } = useUserPhoto();

    const onEditPhotoClick = () => {
        setIsEditingPhoto(true);
    };

    const { firstName, secondName, phoneNumber, email } = userData;

    const userName = getUserName({ name: firstName, surname: secondName });

    // const items: TAccordionItem[] = [getPersonalDataItems({ userData }), getAgreementDataItems({ user, userData })];
    const items: TAccordionItem[] = [getAgreementDataItems({ user, userData })];

    const width = useResize();

    const hasPhoto = photo && photo !== EMPTY_PHOTO_BASE64 && !isError;

    return (
        <>
            <div className={cls.container}>
                <button className={cls.photoWrapper} type="button" onClick={onEditPhotoClick}>
                    {hasPhoto ? (
                        <img className={cls.image} src={photo} alt="user_profile" />
                    ) : (
                        <NoProfilePhoto width={120} height={120} />
                    )}
                    <div className={cls.pencil}>
                        <Pencil />
                    </div>
                </button>
                <div className={cls.data}>
                    <p className={cls.userName}>{userName}</p>
                    <p className={cls.phoneNumber}>{formatPhoneNumber(phoneNumber)}</p>
                    <p className={cls.mail}>{email}</p>
                </div>
                {width >= 768 && <LogoutButton className={cls.logout} />}
            </div>
            {width > 768 ? (
                <Accordion size="m" items={items} />
            ) : (
                <div className={cls.mobileInfo}>
                    <p className={cls.mobileInfoTitle}>Информация по договору</p>
                    {items[0]?.description}
                </div>
            )}
            <Typography as="p" variant="text_14_gray">
                Если вы хотите изменить ваши данные, обратитесь в{' '}
                <Typography as="a" variant="link" target="_blank" href="https://sberbankins.ru/feedback/">
                    поддержку
                </Typography>
            </Typography>
        </>
    );
};
